import HomePage from "./01-main-demo";
import BackToTop from "./backToTop";
import FaqSchema from "@/components/SEO/FaqSchema";
import { getHomeFaqs } from "@/lib/api/faqs";

export default function Home({ faqs }) {
  return (
    <>
      <FaqSchema items={faqs} id="/#faq" />
      <main>
        <HomePage />
        <BackToTop />
      </main>
    </>
  );
}

export async function getServerSideProps() {
  // Fetched server-side so the Q&A reaches crawlers that don't execute JS.
  // getHomeFaqs swallows its own errors and returns [], so the page always renders.
  const faqs = await getHomeFaqs();

  return {
    props: { faqs },
  };
}
